import { handleResponse } from "./service-helpers";

const NBH_API_BASE_URL = import.meta.env.VITE_NBH_URL_ROOT;

export interface DashboardBillingStatistics {
    cashBookBalance: number;
    outstandingFees: {
        count: number;
        totalAmount: number;
        failedAmount: number;
    };
    lastBillingRun: {
        id: string;
        paidCount: number;
        pendingCount: number;
        failedCount: number;
        totalCount: number;
        paidAmount: number;
        pendingAmount: number;
        failedAmount: number;
        totalAmount: number;
    } | null;
}

export interface DashboardMemberStatistics {
    totalCount: number;
    activeCount: number;
    passiveCount: number;
    newMembersThisYear: number;
    cancelledMembersThisYear: number;
}

export interface DashboardPendingConfirmations {
    pendingNdaCount: number;
    pendingPrivacyConsentCount: number;
    pendingMediaConsentCount: number;
    totalPendingCount: number;
}

export async function getDashboardBillingStatistics(token: string): Promise<DashboardBillingStatistics> {
    const response = await fetch(`${NBH_API_BASE_URL}/api/dashboard/billing-statistics`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });

    return await handleResponse<DashboardBillingStatistics>(response) as DashboardBillingStatistics;
}

export async function getDashboardMemberStatistics(token: string): Promise<DashboardMemberStatistics> {
    const response = await fetch(`${NBH_API_BASE_URL}/api/dashboard/member-statistics`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });

    return await handleResponse<DashboardMemberStatistics>(response) as DashboardMemberStatistics;
}

export async function getDashboardPendingConfirmations(token: string): Promise<DashboardPendingConfirmations> {
    const response = await fetch(`${NBH_API_BASE_URL}/api/dashboard/pending-confirmations`, {
        method: "GET",
        headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        }
    });

    return await handleResponse<DashboardPendingConfirmations>(response) as DashboardPendingConfirmations;
}